export default __webpack_public_path__ + "static/media/nonprofit-qr.f2fee8d9.png";